import textLogo from "../assets/textLogo.svg";

const MainScreen = ({ stateCode }) => {
  return (
    <div
      style={{
        textAlign: "center",
        display: stateCode.code === 200 ? "block" : "none",
      }}
    >
      {/* <img src={textLogo} alt="profile" style={styles.mainPageLogo} /> */}
    </div>
  );
};
const styles = {
  mainPageLogo: { height: 200 },
};

export default MainScreen;
